import utils from "core/utils";
import metaObjectHelper from "app/components/common/editor/meta-object-editors/metaObjectHelper";
import componentService from "core/services/componentService/component-service";

export default {
    isTransformationComponent: function(componentName) {
        return (
            [
                componentService.getHumanReadableName("TransformationMasking"),
                componentService.getHumanReadableName("TransformationFieldRemover"),
                componentService.getHumanReadableName("TransformationFieldRenamer"),
                componentService.getHumanReadableName("TransformationFieldTypeModifier"),
                componentService.getHumanReadableName("TransformationFieldFilter"),
                componentService.getHumanReadableName("TransformationFieldSplitter"),
                componentService.getHumanReadableName("TransformationFieldAdder"),
                componentService.getHumanReadableName("TransformationJsonReader"),
                componentService.getHumanReadableName("TransformationTypedEventToWaDbEvent"),
                componentService.getHumanReadableName("TransformationFieldEnricher"),
                componentService.getHumanReadableName("TransformationWaeMetaFilter"),
                componentService.getHumanReadableName("TransformationWaeDbTableFilter"),
                componentService.getHumanReadableName("TransformationWaeOperatorFilter"),
                componentService.getHumanReadableName("TransformationWaeAddUserData"),
                componentService.getHumanReadableName("TransformationWaeToTypedEvent"),
                componentService.getHumanReadableName("TransformationWaeToDwStage"),
                componentService.getHumanReadableName("TransformationWaeDataModifier"),
                componentService.getHumanReadableName("TransformationShield"),
                componentService.getHumanReadableName("TransformationSentinel"),
                componentService.getHumanReadableName("Foreseer"),
            ].indexOf(componentName) !== -1
        );
    },
    isWAEventTypeTransformationRelated: function(componentName) {
        return (
            [
                componentService.getHumanReadableName("TransformationWaeMetaFilter"),
                componentService.getHumanReadableName("TransformationWaeDbTableFilter"),
                componentService.getHumanReadableName("TransformationWaeOperatorFilter"),
                componentService.getHumanReadableName("TransformationWaeAddUserData"),
                componentService.getHumanReadableName("TransformationWaeToTypedEvent"),
                componentService.getHumanReadableName("TransformationWaeToDwStage"),
                componentService.getHumanReadableName("TransformationWaeDataModifier")
            ].indexOf(componentName) !== -1
        );
    },
    isAvailable: function(componentName, metaObject) {
        return new Promise(resolve => {
            if (!this.isTransformationComponent(componentName)) {
                resolve(true);
                return;
            }

            if (metaObject.type === utils.ENTITIES.STREAM) {
                let isWaeEventDataType = metaObjectHelper.isWAEventDataType(metaObject.attributes.dataType);

                if (this.isWAEventTypeTransformationRelated(componentName)) {
                    metaObjectHelper.hasValidDbSource(metaObject.id).then(hasValidDbSource => {
                        resolve(isWaeEventDataType && hasValidDbSource);
                    });
                } else {
                    resolve(!isWaeEventDataType);
                }
            } else {
                resolve(false);
            }
        });
    }
};
